<template>
	<div v-show="show_loading">
		<div class="loading">
			<div class="loader-box">
				<img class="loader" src="~@/assets/img/loader/verde.svg">
				<img class="loader" src="~@/assets/img/loader/azul.svg">
			</div>
		</div>
	</div>
</template>

<script>
export default {

	name: 'Loader',

	computed: {
		show_loading(){
			return this.$store.state.boleto.show_loading;
		}
	}
}
</script>
